import { TEST_IDS } from '@va/constants';
import { useLocale } from '@va/localization';
import { CircularProgress, fontWeights, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { addNumberSeparator, addTransparencyToHexColor } from '@va/util/helpers';

type ScoreVisualizationProps = { score: number; isDisabled: boolean; icon?: (color: string) => React.ReactNode };

export function ScoreVisualization({ score, isDisabled, icon }: ScoreVisualizationProps) {
  const { locale } = useLocale();

  return (
    <div className='flex items-center gap-2' data-testid={TEST_IDS.generic.progress}>
      {icon?.(isDisabled ? '#C3C3C3' : '#969696')}
      <Paragraph size={paragraphSizes.large} weight={fontWeights.semibold} className={'whitespace-nowrap'}>
        {addNumberSeparator(score, locale, { maximumFractionDigits: 2 })} / 100
      </Paragraph>
      <CircularProgress
        className='shrink-0'
        progress={score}
        radius={24}
        stroke={6}
        strokeColor={addTransparencyToHexColor(window.PRIMARY_COLOR, 0.16)}
      />
    </div>
  );
}
